import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { me, logout as apiLogout, adminMe } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await me();
      setUser(u);
      try {
        const r = await adminMe();
        setIsAdmin(!!r.is_admin);
      } catch (e) {
        setIsAdmin(false);
      }
    } catch (e) {
      setUser(null);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const doLogout = async () => {
    try { await apiLogout(); } catch (e) { /* ignore */ }
    setUser(null);
    setIsAdmin(false);
    window.location.href = "/";
  };

  const setUserAndCheck = async (u) => {
    setUser(u);
    if (u) {
      try {
        const r = await adminMe();
        setIsAdmin(!!r.is_admin);
      } catch (e) { setIsAdmin(false); }
    } else {
      setIsAdmin(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser: setUserAndCheck, isAdmin, loading, refresh: checkAuth, logout: doLogout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
